export default __webpack_public_path__ + "static/media/website.a07620f8.png";